import React, { useState, useCallback, FC, ReactElement } from 'react';
import { LoadingProviderType } from '../types/Types';

export const defaultLoadingValue = {};

export const APILoadingContext = React.createContext<LoadingProviderType>(
  defaultLoadingValue as LoadingProviderType,
);

type Props = {
  children: ReactElement;
};

export const APILoadingProvider: FC<Props> = ({ children }) => {
  const [apiLoading, setLoading] = useState(false);

  const setLoad = (val: boolean) => setLoading(val);

  const contextValue = {
    apiLoading,
    setApiLoading: useCallback((val: boolean) => setLoad(val), []),
  } as LoadingProviderType;

  return (
    <APILoadingContext.Provider value={contextValue}>
      {children}
    </APILoadingContext.Provider>
  );
};
